import styled from 'styled-components';
import { hideVisually } from 'polished';
import { fontBody } from 'Styles/fonts';

export const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Strikeout = styled.p`
  ${fontBody(16)};
  color: var(--muted-foreground);
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 3px;

  &:after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-top: 2px solid var(--muted-foreground);
  }
`;

export const Price = styled.p`
  ${fontBody(16)};
  color: var(--foreground);
`;

export const Discount = styled.p`
  ${fontBody(16)};
  color: var(--blue-50);
  text-transform: none;
  margin-left: 4px;
`;

export const Invisible = styled.span`
  ${hideVisually()}
`;
